// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AppConfig } from "../../config/config";
import { SnackMessage, httpStatus } from "../../config/constant";
import { APIService } from "../../utils/apiService";
import {
  ExamPaperRequestInterface,
  GetExamPaperRequestState,
} from "../../utils/types";
import { enqueueSnackbarMessage } from "../commonSlice/common";

const initialState: GetExamPaperRequestState = {
  state: "idle",
  stateMessage: null,
  errorMessage: null,
  response: null,
  backgroundProcess: false,
  backgroundProcessMessage: null,
};

export const getExamPaper = createAsyncThunk(
  "exams/getExamPaper",
  async (payload: ExamPaperRequestInterface, { dispatch }) => {
    return new Promise<{ examPaper: any }>((resolve, reject) => {
      APIService.getInstance()
        .get(
          `${AppConfig.serviceUrls.getExamPaper}/${payload.tokenId}/paper?examId=${payload.examId}&userId=${payload.user.id}&firstName=${payload.user.firstName}&lastName=${payload.user.lastName}`
        )
        .then((resp) => {
          if (resp.status == 200) {
            resolve({ examPaper: resp.data });
          } else {
            reject("Something went wrong");
          }
        })
        .catch((error: Error) => {
          dispatch(
            enqueueSnackbarMessage({
              message: SnackMessage.error.examDetails,
              type: "error",
            })
          );
          reject(error);
        });
    });
  }
);

const examPaperSlice = createSlice({
  name: "examPaper",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getExamPaper.pending, (state, action) => {
        state.stateMessage = "Loading Exams";
        state.state = "loading";
        state.backgroundProcess = true;
        state.backgroundProcessMessage = "Fetching Exam Data";
      })
      .addCase(getExamPaper.fulfilled, (state, action) => {
        state.response = action.payload.examPaper;
        state.state = "success";
        state.backgroundProcess = false;
      })
      .addCase(getExamPaper.rejected, (state, action) => {
        state.state = "failed";
        state.backgroundProcess = false;
      });
  },
});

export default examPaperSlice.reducer;
